const secretKey = "0123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef"

const decryptPayload = async (payload) => {
  
  
  const iv = hexToArrayBuffer(payload.iv);
  const ciphertext = hexToArrayBuffer(payload.ciphertext);
  const key = await getCryptoKey();

  const decrypted = await window.crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    ciphertext
  );

  const decoded = new TextDecoder().decode(decrypted);
  return JSON.parse(decoded);
};

const hexToArrayBuffer = (hex) =>
  new Uint8Array(
    hex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16))
  );

// utils/encryptionService.js

// Convert string to Uint8Array
const toUint8Array = (str) => new TextEncoder().encode(str);
// Generate 256-bit (32 bytes) AES key from secret string
export const getCryptoKey = async () => {
  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    toUint8Array(secretKey),
    "PBKDF2",
    false,
    ["deriveKey"]
  );
  return window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: toUint8Array("unique-salt"), // fixed salt (or send with payload)
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-CBC", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
};

const arrayBufferToHex = (buffer) =>
  [...new Uint8Array(buffer)]
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

const encryptedPayload = async (data) => {
  const iv = crypto.getRandomValues(new Uint8Array(16)); // 128-bit IV
  const key = await getCryptoKey();

  const encodedData = new TextEncoder().encode(JSON.stringify(data));
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    encodedData
  );

  return {
    iv: arrayBufferToHex(iv),
    ciphertext: arrayBufferToHex(encrypted),
  };
};

 const encryptQuery = async (text) => {
  const key = await getCryptoKey();
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const encodedData = new TextEncoder().encode(text);
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    encodedData
  );

  // Combine IV + encrypted bytes
  const combined = new Uint8Array(iv.length + encrypted.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(encrypted), iv.length);

  return arrayBufferToHex(combined.buffer); // IV + ciphertext
};


export { encryptedPayload, decryptPayload,encryptQuery };